import { CategoryAddedMessageTemplateComponent } from './category-added';
import { CategoryAlreadyExistsMessageTemplateComponent } from './category-already-exists';
import { CategoryUpdatedMessageTemplateComponent } from './category-updated';

export * from './category-added';
export * from './category-updated';
export * from './category-already-exists';


export const CategoryMessages = [
    CategoryAddedMessageTemplateComponent,
    CategoryUpdatedMessageTemplateComponent,
    CategoryAlreadyExistsMessageTemplateComponent
];